module.exports = __webpack_public_path__ + "static/media/cross.c102b50a.png";